// CN marketplace configurations related to YourOrder scope.

// BestSeller Asins list maximum length
export const MAXIMUM_BESTSELLER_ASINS_LENGTH = 150;
